export const EMAIL_TEMPLATE_TYPES = {
  messaging: 'Messaging/Invitations',
  gift_certificates: 'Gift Certificates',

  __proto__: {
    getOptions: () => Object.entries(EMAIL_TEMPLATE_TYPES).map(([value, label]) => ({ value, label }))
  }
}